import { Location } from 'history';

import { resolveProfileViewSource } from 'utils/applicantProfileView';

export interface LoadQueueInput {
  location: Location;
  currentId: string;
  tableIds: string[];
  searchQuery?: string;
  stageId?: string;
  funnelId?: string;
}

export function isUniversalSearchOpen(location: Pick<Location, 'search'>) {
  return (
    new URLSearchParams(location.search).get('applicantOpenSource') ===
    'universal_search'
  );
}

export async function loadQueue({
  location,
  currentId,
  tableIds,
}: LoadQueueInput): Promise<{ ids: string[]; truncated: boolean } | null> {
  const source = resolveProfileViewSource({
    isPagination: false,
    pathname: location.pathname,
    search: location.search,
    accountSlug: location.pathname.split('/')[1],
  });
  if (
    isUniversalSearchOpen(location) ||
    (source !== 'pipeline_board' &&
      source !== 'applicant_list' &&
      source !== 'applicant_search') ||
    !tableIds.includes(currentId)
  ) {
    return null;
  }
  return { ids: [...tableIds], truncated: false };
}
